export const getArticleTeaserData = (
  tenantId: string,
  articleId: string | number
): Promise<any> => {
  return new Promise((resolve, reject) => {
    fetch(`https://feed-prod.unitycms.io/14/content/${articleId}?reduced`)
      .then((response) => {
        if (!response.ok) {
          reject('Failed to fetch article teaser')
        }
        return response.json()
      })
      .then((data) => {
        const teaser = data.content.meta.teaser.default
        resolve({
          title: teaser.title,
          titleHeader: teaser.titleHeader,
          imageSrc: teaser.image.fileUrl,
          isPremium: teaser.settings.premium,
          url: `https://www.${tenantId}.ch/${articleId}`,
          id: articleId,
        })
      })
      .catch((error) => {
        reject(error)
      })
  })
}
